import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedReactionIds } from './reactionsPopupSelector';
import { updateReaction } from '../reactionActions';

type ReactionPopupHooksResponse = {
    selectedReactionIds: string[];
    onSelectReaction: (emojiCode: string) => void;
};

const useReactionsPopupHooks = (elementIds: string[]): ReactionPopupHooksResponse => {
    const selectedReactionIds = useSelector((state) => getSelectedReactionIds(state, elementIds));

    const dispatch = useDispatch();
    const dispatchAddReaction = useCallback(
        ({ elementIds, emojiCode }: { elementIds: string[]; emojiCode: string }) =>
            dispatch(updateReaction({ updateIds: elementIds, emojiCode })),
        [],
    );

    const onSelectReaction = useCallback(
        (emojiCode: string) => {
            dispatchAddReaction({
                elementIds,
                emojiCode,
            });
        },
        [elementIds],
    );

    return {
        selectedReactionIds,
        onSelectReaction,
    };
};

export default useReactionsPopupHooks;
